import React from 'react';
import './App.css';
import Footer from './components/layout/Footer/Footer';
import Header from './components/layout/Header/Header';
import Homepage from './pages/Homepage/Homepage';
import { Route, Routes, useLocation } from 'react-router-dom';
import Loginpage from './pages/Loginpage/Loginpage';
import Accountsettingpage from './pages/Accountsettingpage/Accountsettingpage';
import Createaccountpage from './pages/Createaccountpage/Createaccountpage';
import Myaccountpage from './pages/Myaccountpage/Myaccountpage';
import Logedout from './components/Protectedrouters/Logedout';
import Logedin from './components/Protectedrouters/Logedin';

function App() {

  const path = useLocation()

  return (
    <>
      {/* Header */}

      {path.pathname !== "/loginpage" && <Header />}

      <Routes>

        {/* Home page */}

        <Route path='/' element={<Logedout ><Homepage /></Logedout>} />

        <Route path='homepage' element={<Homepage />} />

        {/* Login page */}

        <Route path='loginpage' element={<Loginpage />} />

        {/* Account setting page */}

        <Route path='accountsettingpage' element={<Logedin><Accountsettingpage /></Logedin>} />

        {/* Create an account pagr */}

        <Route path='createanaccount' element={<Logedin><Createaccountpage /></Logedin>} />

        {/* My accounr page */}

        <Route path='myaccountpage' element={<Logedin><Myaccountpage /></Logedin>} />

      </Routes>

      {/* Footer */}

      {path.pathname !== "/loginpage" && <Footer />}
    </>
  );
}

export default App;
